import actions from './actions'
import mutations from './mutations'
import getters from './getters'

import reviews from './reviews/store'
import interim from './interim/store'

const state = {
  codingScheduleRequest: {},
  codingScheduleRequests: [],
  reviewRequests: [],
  interimRequests: [],
  specialties: [],
  ambulatorySpecialtiesLookup: [],
  schedulePeriods: [],
  allRequests: []
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    reviews,
    interim
  }
}

export default module
